import React, { useState } from "react"
import {
    Box,
    CssBaseline,
    Grid,
    ThemeProvider,
    Typography,
} from "@mui/material"
import ButtonWithIcon from "src/v2/components/Button/Button"
import { ReactComponent as ArrowRightIcon } from "src/v2/assets/icons/arrow-right-icon.svg"
import { ReactComponent as ArrowLeftIcon } from "src/v2/assets/icons/arrow-left-icon.svg"
import { ReactComponent as MailIcon } from "src/v2/assets/icons/mail-icon.svg"
import { Logo } from "../../components/Logo/logo"
import InputWithIcon from "../../components/Input/inputWithIcon"
import { Link } from "react-router-dom"
import theme from "../../theme/theme"
import AuthService from "../../../services/auth-service"
import { validateEmail } from "../../utils/validate-email/validate-email"
import Loader from "../../components/Loader/loader"
import LoaderOverlay from "../../components/LoaderOverlay/loader-overlay"
import { useDocumentTitle } from "../../hooks/useDocumentTitle"

const RecoverPasswordPage = () => {
    const [
        isEnabledButtonSentEmailRecoverPassword,
        setIsEnableButtonSentEmailRecoverPassword,
    ] = useState(true)
    const [isErrorSentEmail, setIsErrorSentEmailRecoverPassword] =
        useState(false)
    const [isEmailSent, setIsEmailSent] = useState(false)
    const [email, setEmail] = useState("")

    const authService = new AuthService()

    useDocumentTitle("Recuperação de Senha")

    const submitHandlerRecoverPassword = async (e) => {
        e.preventDefault()
        if (!email) return
        setIsEnableButtonSentEmailRecoverPassword(false)
        try {
            await authService.resetPassword(email)
            setIsEmailSent(true)
        } catch (e) {
            setIsErrorSentEmailRecoverPassword(true)
        } finally {
            setIsEnableButtonSentEmailRecoverPassword(true)
        }
    }

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />

            <Grid container>
                <Grid
                    item
                    sm={4}
                    md={12}
                    sx={{
                        backgroundImage: 'url("/background/login.webp")',
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        height: "100vh",
                        width: "100%",
                    }}
                    alignContent="center"
                >
                    {!isEnabledButtonSentEmailRecoverPassword && (
                        <LoaderOverlay>
                            <Loader />
                        </LoaderOverlay>
                    )}
                    <Box
                        maxWidth="388px"
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        p={3}
                        bgcolor={theme.palette.text.primary}
                        ml={{ xs: 2, sm: 3, md: 2, lg: 16 }}
                        mr={{ xs: 2, sm: 3, md: 2, lg: 16 }}
                        height={{ md: "100%", xs: "auto" }}
                        sx={{
                            "@media (min-width:420px) and (max-width:833px)": {
                                margin: "auto",
                            },
                        }}
                    >
                        <Logo />

                        {isEmailSent ? (
                            <Box
                                display="flex"
                                flexDirection="column"
                                mt={3}
                                gap={3}
                                noValidate
                                sx={{ width: "100%" }}
                            >
                                <Typography
                                    variant="h3"
                                    color={theme.palette.primary.contrastText}
                                    textAlign="center"
                                    primaryAlign="center"
                                >
                                    Pronto!
                                </Typography>
                                <Typography
                                    variant="textBody"
                                    color={theme.palette.primary.contrastText}
                                    textAlign="center"
                                >
                                    Enviamos um e-mail para {email} com as
                                    instruções para recuperar sua senha
                                </Typography>

                                <ButtonWithIcon
                                    icon={<ArrowLeftIcon />}
                                    size={"lg"}
                                    component={Link}
                                    to="/"
                                    sx={{
                                        width: "min-content",
                                        margin: "auto",
                                    }}
                                >
                                    VOLTAR
                                </ButtonWithIcon>
                            </Box>
                        ) : (
                            <Box
                                component={"form"}
                                onSubmit={submitHandlerRecoverPassword}
                                autoComplete="off"
                                display="flex"
                                flexDirection="column"
                                gap={3}
                                noValidate
                                sx={{ width: "100%" }}
                            >
                                <Box mt={3} gap={3}>
                                    <Box
                                        display="flex"
                                        flexDirection="column"
                                        gap={3}
                                    >
                                        <InputWithIcon
                                            type="email"
                                            label="E-mail cadastrado"
                                            startIcon={<MailIcon />}
                                            onChange={(e) =>
                                                setEmail(e.target.value)
                                            }
                                            value={email}
                                            error={isErrorSentEmail}
                                            helperText={"E-mail inválido"}
                                        />
                                    </Box>
                                </Box>
                                <Box
                                    alignItems="end"
                                    display="flex"
                                    flexDirection="row"
                                    justifyContent="space-between"
                                >
                                    <Typography
                                        component={Link}
                                        to="/"
                                        variant="body2"
                                        sx={{
                                            marginBottom: 2,
                                            color: theme.palette.primary.main3,
                                            textDecoration: "none",
                                            cursor: "pointer",
                                            "&:hover": {
                                                textDecoration: "underline",
                                            },
                                        }}
                                    >
                                        Voltar
                                    </Typography>

                                    <ButtonWithIcon
                                        type={"submit"}
                                        size={"lg"}
                                        icon={<ArrowRightIcon />}
                                        disabled={
                                            !isEnabledButtonSentEmailRecoverPassword ||
                                            !validateEmail(email)
                                        }
                                    >
                                        ENVIAR
                                    </ButtonWithIcon>
                                </Box>
                            </Box>
                        )}
                    </Box>
                </Grid>
            </Grid>
        </ThemeProvider>
    )
}

export default RecoverPasswordPage
